import { render, staticRenderFns } from "./SettingsSubMenuModuleGiftCard.vue?vue&type=template&id=669ac7b1&scoped=true"
import script from "./SettingsSubMenuModuleGiftCard.vue?vue&type=script&lang=js"
export * from "./SettingsSubMenuModuleGiftCard.vue?vue&type=script&lang=js"
import style0 from "./SettingsSubMenuModuleGiftCard.vue?vue&type=style&index=0&id=669ac7b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ac7b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VCardActions,VCardTitle,VContainer,VFlex,VIcon,VLayout,VMain})
